import { ISendingScheduleRepository, SendingSchedulesQuery } from '../../ports/ISendingScheduleRepository'
import { SendingScheduleEntity } from '../../../domain/entities/SendingSchedule'

export class ListSendingSchedulesUseCase {
  constructor(private repo: ISendingScheduleRepository) {}
  execute(params: SendingSchedulesQuery): Promise<{ items: SendingScheduleEntity[]; page: number; perPage: number; total: number }> {
    return this.repo.list(params)
  }
}
